<template>
  <BreadCrumb PageTitle="Ticket Preview" />
  <TicketPreview />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import TicketPreview from "../../template-components/SupportDesk/TicketPreview/TicketPreview.vue";

export default defineComponent({
  name: "TicketPreviewPage",
  components: {
    BreadCrumb,
    TicketPreview,
  },
});
</script>